import { TypedDocumentNode, gql } from '@apollo/client';

import {
  FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_ARENA,
  FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_FRIENDLIES,
  FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_OVERVIEW,
  FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_SETUP,
} from '@sorare/core/src/constants/__generated__/routes';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { isGameLive, isGameScheduled } from '@sorare/gameplay/src/lib/so5';

import { useGamePath_footballRivalsGame } from './__generated__/useGamePath.graphql';

type Props = {
  rivalsGame?: useGamePath_footballRivalsGame | null;
};
export const useGamePath = ({ rivalsGame }: Props) => {
  const {
    flags: { rivalsSquadsFirstIteration = false },
  } = useFeatureFlags();

  if (!rivalsGame) {
    return FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_SETUP;
  }

  const { myLineup, myArenaRequest, game } = rivalsGame;
  const status = game.statusTyped;

  if (status) {
    if (isGameLive(status)) {
      if (myArenaRequest) {
        return FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_ARENA;
      }
      return FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_FRIENDLIES;
    }
    if (isGameScheduled(status) && !myLineup) {
      return FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_SETUP;
    }
  }

  return rivalsSquadsFirstIteration
    ? FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_ARENA
    : FOOTBALL_PLAY_RIVALS_MATCHES_DATE_SLUG_OVERVIEW;
};

useGamePath.fragments = {
  footballRivalsGame: gql`
    fragment useGamePath_footballRivalsGame on FootballRivalsGame {
      slug
      id
      myArenaRequest {
        id
      }
      myLineup {
        id
      }
      game {
        id
        statusTyped
      }
    }
  ` as TypedDocumentNode<useGamePath_footballRivalsGame>,
};
